import React from 'react';
import AlertModal from '../AlertModal';

const ReportModals = ({
  confirmationModal,
  setConfirmationModal,
  showUnsavedChangesAlert,
  handleCancelAction,
  handleDiscardChanges,
  handleSaveAndContinue,
  isSaving
}) => {
  return (
    <>
      {/* Generic confirmation modal */}
      <AlertModal
        show={!!confirmationModal}
        onHide={() => setConfirmationModal(null)}
        title={confirmationModal?.title}
        alertText={confirmationModal?.alertText}
        continueButtonText={confirmationModal?.continueButtonText}
        dismissButtonText={confirmationModal?.dismissButtonText}
        onContinueClick={() => {
          confirmationModal?.onContinue();
        }}
        onDismissClick={() => setConfirmationModal(null)}
        continueButtonVariant="success"
      />

      {/* Unsaved changes alert */}
      <AlertModal
        show={showUnsavedChangesAlert}
        onHide={handleCancelAction}
        onDismissClick={handleDiscardChanges}
        onContinueClick={handleSaveAndContinue}
        alertText="You have unsaved changes. Do you want to save them before continuing?"
        dismissButtonText="Discard Changes"
        dismissButtonVariant="danger"
        continueButtonText="Save Changes"
        continueButtonVariant="success"
        showProgress={isSaving}
        progressText="Saving..."
      />
    </>
  );
};

export default ReportModals;
